import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/NotificationLogsPageQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const notificationLogsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-notifications-log" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			notificationLogs: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectIds: context?.query?.projectId,
					notificationType: 'INTERNAL_NOTIFICATION',
					notificationActionType: 'USER_INVITE',
					recipientId: '',
				},
			},
		},
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
		},
	}),
});
